(() => {
  function init(root) {
    if (root.dataset.cwxReady) return;
    root.dataset.cwxReady = 'true';
    const select = root.querySelector('[data-cwx-programme]');
    const status = root.querySelector('[data-cwx-status]');
    root.querySelectorAll('[data-cwx-choice]').forEach(link => {
      link.addEventListener('click', () => {
        if (!select) return;
        select.value = link.dataset.cwxChoice;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        if (status) status.textContent = `${status.dataset.label} ${select.options[select.selectedIndex].text}`;
        // Keep the native anchor destination and move keyboard focus to the form.
        const heading = root.querySelector('#corporate-enquiry-title');
        if (heading) requestAnimationFrame(() => heading.focus({ preventScroll: true }));
      });
    });
    const feedback = root.querySelector('[data-cwx-feedback]');
    if (feedback) {
      const revealFeedback = () => {
        feedback.focus({ preventScroll: true });
        feedback.scrollIntoView({ block: 'center', behavior: 'auto' });
      };
      if (document.readyState === 'complete') revealFeedback();
      else window.addEventListener('load', revealFeedback, { once: true });
    }
  }
  document.querySelectorAll('[data-cwx]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-cwx]').forEach(init);
  });
})();
